import { useState, useEffect } from "react";
import InvelpsGlobalNav from "./InvelpsGlobalNav";

const THEME_KEY = "invelpsTheme";

function readDarkMode() {
  if (typeof window === "undefined") return false;
  return window.localStorage.getItem(THEME_KEY) === "dark";
}

/** En-tête unique : barre verte INVELPS (nav + Synthèse / Leaders / Flux intégrés) */
export default function MarketPageShell() {
  const [darkMode, setDarkMode] = useState(readDarkMode);

  useEffect(() => {
    window.localStorage.setItem(THEME_KEY, darkMode ? "dark" : "light");
  }, [darkMode]);

  return (
    <InvelpsGlobalNav
      darkMode={darkMode}
      onToggleDark={() => setDarkMode((d) => !d)}
    />
  );
}
